import Vue from 'vue'
import Router from 'vue-router'
import SourceList from '@/components/SourceList'
import Student from '@/components/Student'
import StudentList from '@/components/StudentList'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'StudentList',
      component: StudentList
    },
    {
      path: '/sources',
      name: 'Sourcelist',
      component: SourceList
    },
    {
      path: '/:id',
      name: 'Student',
      component: Student,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js